<div class="auth-container verify-account-container">
  <div>
    <h1 class="primary-font-semibold heading">
      {{ 'authentication.enter_verification_code' | translate }}
    </h1>

    @if (errorMessage(); as errorMessageContent) {
      <div class="error-message-container">
        <p class="error-message primary-font-medium form-description">
          {{ errorMessageContent }}
        </p>
      </div>
    } @else {
      <p class="primary-font-medium form-description">
        {{ 'authentication.enter_digit_email' | translate }} <br />
        <span class="email-address">"{{ maskedEmailForDisplay() }}"</span>
      </p>
    }

    @if (successMessage()) {
      <p class="success-message primary-font-medium form-description">
        {{ successMessage() }}
      </p>
    }
  </div>

  <div class="form-container">
    <app-otp-input
      [setting]="otpInputSettings()"
      [hasError]="isVerificationError()"
      (valueChange)="onOtpInputChange($event)"
    >
    </app-otp-input>

    <button
      class="auth-button primary-button custom-button rounded-pill primary-font-medium"
      type="button"
      (click)="submitOtp().subscribe()"
      [disabled]="enteredOtpCode().length !== otpInputSettings().length"
    >
      @if (isSubmittingOtp()) {
        <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
      } @else {
        {{ 'authentication.submit_button' | translate }}
      }
    </button>
  </div>
</div>
